/**
 * https://www.joshwcomeau.com/snippets/react-hooks/use-prefers-reduced-motion/
 */

import { useState, useEffect } from 'react';
const QUERY = '(prefers-reduced-motion: no-preference)';
const getInitialState = () => true;
function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialState);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);

    const updatePreference = event => {
      setPrefersReducedMotion(!event.matches);
    };

    updatePreference(mediaQueryList);

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', updatePreference);

      return () => {
        mediaQueryList.removeEventListener('change', updatePreference);
      };
    }

    mediaQueryList.addListener(updatePreference);

    return () => {
      mediaQueryList.removeListener(updatePreference);
    };
  }, []);

  return prefersReducedMotion;
}

export default usePrefersReducedMotion;
